import { ThemeTonalRange } from '@philips-emr/tws-constants';
import Controller, { OnClick } from '@philips-emr/tws-core/lib/client';
import { ModalService } from '@philips-emr/tws-core/lib/services';

import { FragmentNames, MeusDadosAliases } from '../../codegen';
import { Routes } from '../../definitions/routes';
import BaseController from '../base/base-controller';

@Controller({ fragment: FragmentNames.MEUS_DADOS })
export default class MeusDadosController extends BaseController {

  @OnClick(MeusDadosAliases.LINK_ALTERAR_SENHA)
  onAlterarSenhaClick(): void {
    const { nrSeqBeneficiario } = this.context.getBulkData();

    ModalService.openDefault({
      id: FragmentNames.MODAL_REDEFINIR_SENHA,
      closeable: true,
      contextData: { nrSeqBeneficiario },
      theme: ThemeTonalRange.ULTRA_LIGHT,
      title: 'beneficiary.redefina-senha',
      fragment: FragmentNames.MODAL_REDEFINIR_SENHA,
    });
  }

  @OnClick(MeusDadosAliases.LINK_PRIVACY)
  onClickPrivacy(): void {
    this.historyService.push(Routes.PRIVACY);
  }
}
